import css from 'styled-jsx/css';

const styles = css.global`.rotoql-schedule__container{display:flex;flex-direction:column;color:#262626;max-width:1380px;width:100%}@media only screen and (min-width: 320px){.rotoql-schedule__container{flex-direction:column}}@media only screen and (min-width: 768px){.rotoql-schedule__container{flex-direction:column}}@media only screen and (min-width: 1024px){.rotoql-schedule__container{flex-direction:row}}`;

export default styles;